import Swiper from 'swiper';

const container = $('.js-slider-gallery-brands');

function initG() {
  if (container.find('.brand').length < 24) {
    new Swiper('.js-slider-gallery-brands.swiper-container', {
      slidesPerView: 6,
      centerInsufficientSlides: true,
      spaceBetween: 20,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      },
      navigation: {
        nextEl: '.js-next-brand',
        prevEl: '.js-prev-brand',
      },
      breakpoints: {
        1199: {
          slidesPerView: 5
        },
        767: {
          slidesPerView: 2,
          spaceBetween: 10
        },
      }
    });

  } else {

    new Swiper('.js-slider-gallery-brands.swiper-container', {
      slidesPerView: 6,
      slidesPerColumn: 4,
      spaceBetween: 20,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      },
      navigation: {
        nextEl: '.js-next-brand',
        prevEl: '.js-prev-brand',
      },
      breakpoints: {
        1199: {
          slidesPerView: 4,
          slidesPerColumn: 3,
        },
        767: {
          slidesPerView: 2,
          slidesPerColumn: 1,
          spaceBetween: 10
        },
      }
    });
  }
}

if (container.length) {
  initG();
}


$(window).resize(function () {
  setTimeout(() => {
    initG();
  }, 100);
});